module.exports = __webpack_public_path__ + "static/media/Lato-Semibold.8b4f872c.woff2";